import { render } from "./ChooseAddress.vue?vue&type=template&id=a5c1af90&scoped=true"
import script from "./ChooseAddress.vue?vue&type=script&lang=js"
export * from "./ChooseAddress.vue?vue&type=script&lang=js"

import "./ChooseAddress.vue?vue&type=style&index=0&id=a5c1af90&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c1af90"]])

export default __exports__